import { getForecastDate } from "./dateUtils.js";

export const translations = {
  en: {
    title: "DISASTER RISK REDUCTION DECISION SUPPORT SYSTEM",
    warningTitle: "Landslide Advisory for Timor-Leste",
    advisoryNumber: "Advisory number: ",
    issuedBy: "Issued by:",
    issuedAt: "Date & Time: ",
    overview: "Overview:",
    overviewTextPlaceholder: "Overview content is dynamically generated based on the selected date and filters.",
    tableHeaders: ["Municipality", "Impact", "Probabilidade"],
    observation: "Landslide Forecast Date:    ",
    impact: "Risk with Rainfall information:",
    ocean: "Significant Wave Height Information:",
    generalAdvisory: "General Advisory:",
    advisoryIntro:
      "The Disaster Risk Reduction Decision Support System advises the following precautions to ensure safety and mitigate landslide risks:",
    advisoryTableHeaders: ["Type", "Advisory"],
    advisoryPoints: [],
    rainfallAlertMap: "Rainfall Alert Forecast for next 3 days:",
    rainfallTableHeaders: [
      [
        {
          content: "Sl No",
          rowSpan: 2,
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: "Municipality",
          rowSpan: 2,
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: "Post Admin",
          rowSpan: 2,
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: "Suco",
          rowSpan: 2,
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: getForecastDate(0),
          colSpan: 2,
          styles: { halign: "center" },
        },
        {
          content: getForecastDate(1),
          colSpan: 2,
          styles: { halign: "center" },
        },
        {
          content: getForecastDate(2),
          colSpan: 2,
          styles: { halign: "center" },
        },
      ],
      [
        "Rainfall (mm)",
        "Characteristics",
        "Rainfall (mm)",
        "Characteristics",
        "Rainfall (mm)",
        "Characteristics",
      ],
    ],
    noteLabel: "Note:",
    noteText:
    "The report is valid up to 9 AM UTC [VALID_UP_DATE]. Please monitor the website for additional information and alerts issued by the Department of Meteorology.",
    message: "Some sucos have a higher chance of landslides because a significant portion of their area is on steep hills with weaker soil conditions. This means landslides could happen even without heavy rain and/or little trigger.",
    footer:
      "DISASTER RISK REDUCTION DECISION SUPPORT SYSTEM (DRRDSS), Email: timor-leste@rimes.int, Phone: +670-74520986",
    page: "Page [i] of [pageCount]",
    rainfallLegendLabel: "Rainfall Characteristics Legend",
  },
  tetum: {
    title: "SISTEMA APOIU DESIZAUN REDUSAUN RISKU DEZASTRE",
    warningTitle: "Aviso Kona-ba Siklonu Tropikal iha Timor-Leste",
    advisoryNumber: "Númeru Aviso: ",
    issuedBy: "Ema-husik husi: ",
    issuedAt: "Data no Oras: ",
    overview: "Visaun Jeral",
    overviewTextPlaceholder: "Conteúdu Visaun Jeral ne'e gera dinamikamente hosi data no filtru hili.",
    tableHeaders: ["Munisípiu", "Impaktu", "Probabilidade"],
    observation: "Data Previsaun Rai Mota:",
    impact: "Risku ho informasaun udan:",
    ocean: "Informasaun Kona-ba Altura Signifikante Tasi Fuan:",
    generalAdvisory: "Konsellu Jeral:",
    advisoryIntro:
      "Sistema Apoiu Desizaun Redusaun Risku Dezastre konsella medida prevensaun tuir mai atu garante seguransa no mitiga risku siklonu:",
    advisoryTableHeaders: ["Tipu", "Konsellu"],
    advisoryPoints: [],
    rainfallAlertMap: "Previsaun Alerta Udan ba loron 3 ne’ebé mai:",
    rainfallTableHeaders: [
      [
        {
          content: "N°",
          rowSpan: 2,
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: "Municipio",
          rowSpan: 2,
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: "Administradór Postu",
          rowSpan: 2,
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: "Suco",
          rowSpan: 2,
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: getForecastDate(0),
          colSpan: 2,
          styles: { halign: "center" },
        },
        {
          content: getForecastDate(1),
          colSpan: 2,
          styles: { halign: "center" },
        },
        {
          content: getForecastDate(2),
          colSpan: 2,
          styles: { halign: "center" },
        },
      ],
      [
        "Lluvia (mm)",
        "Características",
        "Lluvia (mm)",
        "Características",
        "Lluvia (mm)",
        "Características",
      ],
    ],
    noteLabel: "Nota:",
    noteText:
    "Relatóriu ne’e válidu to’o 9 AM UTC [VALID_UP_DATE]. Favor monitoriza website ba informasaun adisional no alerta sira ne’ebé Departamentu Meteorolojia ema-husik.", 
    message: "Sucos balu iha posibilidádu aas atu akontese rai-motan, tanba parte boot husi ninia área iha foho to’os ho rai ne’ebé fraku. Ne’e hatudu katak rai-motan bele akontese maski la iha udan boot ka ho trigger ki’ik de’it.",
    footer:
      "SISTEMA APOIU DESIZAUN REDUSAUN RISKU DEZASTRE (DRRDSS), Email: timor-leste@rimes.int, Telefone: +670-74520986",
    page: "Pajina [i] husi [pageCount]",
    rainfallLegendLabel: "Leienda Karakterístika Udan",
  },
};

export const rainfallCharacteristicsTranslations = {
  en: {
    NoRisk: "No-Rain",
    Low: "Low-Rain",
    Medium: "Medium-Rain",
    High: "High-Rain",
    "N/A": "N/A",
  },
  tetum: {
    NoRisk: "La iha Udan",
    Low: "Udan Kraik",    
    Medium: "Udan Meiu", 
    High: "Udan Forte",    
    "N/A": "Laiha Dadus",
  },
};

export const landslideCharacteristicsTranslations = {
  en: {
    NoRisk: "No-Risk", 
    Low: "Low",  
    Medium: "Medium", 
    High: "High",   
    "N/A": "N/A",
  },
  tetum: {
    NoRisk: "La-Risku", 
    Low: "Kraik",  
    Medium: "Meiu", 
    High: "Forte", 
    "N/A": "Laiha Dadus",
  },
};

export const characteristicColors = {
  NoRisk: [148, 203, 85],
  Low: [243, 235, 18],
  Medium: [243, 155, 58],
  High: [230, 45, 58],
  "N/A": [222, 222, 223],
};